import * as React from 'react'

import { observer } from 'mobx-react'

import NotificationsSettingsControls from '~/client/src/shared/components/NotificationsSettingsControls/NotificationsSettingsControls'

import BottomNavigationNavBar from '../../components/BottomNavigationNavBar/BottomNavigationNavBar'
import MobileView from '../../components/MobileView'

// localization: no display text to translate

@observer
export default class NotificationsSettingsView extends React.Component {
  public render() {
    return (
      <MobileView
        content={<NotificationsSettingsControls className="col pa10" />}
        footer={<BottomNavigationNavBar />}
      />
    )
  }
}
